const Home = () => {
  return (
    <>
      <section className="section">
        <h2>Home</h2>
      </section>
    </>
  );
};
export default Home;
